export default [
    {
        path: "voucher-hotel-ticket",
        component: () => import("@/views/voucher-hotel-ticket/VoucherHotelIndex.vue"),
        meta: { 
            requiresAuth: true,
            roles: [
                'Super Admin',
                'Admin Office'
            ]
        },
    },
]
